// extracted by mini-css-extract-plugin
module.exports = {"title":"PackageList_title__7SQ3K","list":"PackageList_list__od7lR"};